// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"42e1ae9e","455":"8d633c81","488":"2c6b478b"}[chunkId] + ".chunk.js";
};